import React, { useState } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const ChangePassword = ({ show, handleClose, handleSubmit, onSubmit, register, errors }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Reset Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="col-12 col-md-12">
            <div className="form-group py-3 mb-0">
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter New Password"
                  {...register("password", { required: "Password is required" })}
                />
                <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </InputGroup>
              {errors?.password && (
                <p className="text-danger mt-2 mb-0">
                  {errors.password.message}
                </p>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <Button variant="danger" size="sm" onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="primary" size="sm">Save</Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ChangePassword;
